// src/finances/FinancialOverview.js
import React from 'react';

function FinancialOverview() {
  // Mock aggregated data - replace with real API later
  const overview = {
    totalRevenueYTD: 285000,
    totalExpensesYTD: 162000,
    grossProfitYTD: 123000,
    netProfitYTD: 98000,
    projectedProfit: 145000,
    totalSalesTax: 22800,
    laborBurdenYTD: 42000,
    overdueInvoices: 14500,
    cashOnHand: 78000,
  };

  return (
    <div className="min-h-screen bg-gray-950 text-zinc-100 p-8 space-y-10">
      {/* Header - Owner-only feel */}
      <div className="flex justify-between items-center border-b border-gray-800 pb-8">
        <h1 className="text-3xl font-bold tracking-tight">Financial Overview</h1>
        <div className="text-sm text-zinc-500">Last updated: Jan 18, 2026 • Owner View Only</div>
      </div>

      {/* Key Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-gray-900 rounded-2xl p-6 border border-gray-800/50 shadow-2xl">
          <p className="text-zinc-400 text-sm">YTD Revenue</p>
          <p className="text-3xl font-bold text-indigo-400 mt-2">${overview.totalRevenueYTD.toLocaleString()}</p>
        </div>
        <div className="bg-gray-900 rounded-2xl p-6 border border-gray-800/50 shadow-2xl">
          <p className="text-zinc-400 text-sm">YTD Net Profit</p>
          <p className="text-3xl font-bold text-green-400 mt-2">${overview.netProfitYTD.toLocaleString()}</p>
        </div>
        <div className="bg-gray-900 rounded-2xl p-6 border border-gray-800/50 shadow-2xl">
          <p className="text-zinc-400 text-sm">Projected Profit</p>
          <p className="text-3xl font-bold text-cyan-400 mt-2">${overview.projectedProfit.toLocaleString()}</p>
        </div>
        <div className="bg-gray-900 rounded-2xl p-6 border border-gray-800/50 shadow-2xl">
          <p className="text-zinc-400 text-sm">Overdue Invoices</p>
          <p className="text-3xl font-bold text-red-400 mt-2">${overview.overdueInvoices.toLocaleString()}</p>
        </div>
      </div>

      {/* Charts & Details - Placeholder */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-gray-900 rounded-2xl border border-gray-800/50 p-8 shadow-2xl">
          <h2 className="text-xl font-bold mb-6">Profit & Loss Trend</h2>
          <div className="h-64 bg-gray-800 rounded-xl flex items-center justify-center">
            <p className="text-zinc-500">P&L Graph Placeholder (monthly net profit)</p>
          </div>
        </div>

        <div className="bg-gray-900 rounded-2xl border border-gray-800/50 p-8 shadow-2xl">
          <h2 className="text-xl font-bold mb-6">Key Metrics</h2>
          <div className="space-y-4">
            <div className="flex justify-between">
              <span className="text-zinc-400">Total Sales Tax Collected</span>
              <span className="font-medium">${overview.totalSalesTax.toLocaleString()}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-zinc-400">Labor Burden YTD</span>
              <span className="font-medium">${overview.laborBurdenYTD.toLocaleString()}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-zinc-400">Cash on Hand</span>
              <span className="font-medium text-green-400">${overview.cashOnHand.toLocaleString()}</span>
            </div>
          </div>
        </div>
      </div>

      <p className="text-center text-zinc-500 mt-12 italic">
        Owner/Superadmin view only • Sensitive financial data protected
      </p>
    </div>
  );
}

export default FinancialOverview;